import { ListChecks } from "lucide-react";
import {
  MyTasksParamsSchema,
  defaultMyTasksParams,
  type MyTasksParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { MyTasksWidget } from "./Component.js";
import { MyTasksEditor } from "./Editor.js";
import type { MyTasksView } from "./types.js";

/**
 * My Tasks — dashboard data widget (Personal). `TParams` = saved
 * `{ mode?, priorities? }`; `TView` = resolved `{ tasks, mode, priorities }`.
 */
export const myTasksDef: SqlWidgetDef<MyTasksParams, MyTasksView> = {
  kind: "myTasks",
  label: "My Tasks",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 480, h: 360 },
  defaultParams: defaultMyTasksParams,
  Component: MyTasksWidget,
  storage: "sql",
  schema: MyTasksParamsSchema,
  accent: "purple",
  icon: ListChecks,
  subtitle: "Personal inbox",
  defaultRoster: false,
  category: "single",
  layout: { col: 1, row: 1, width: 480, height: 360 },
  dashboard: {
    icon: ListChecks,
    defaultWidth: "wide",
    category: "Personal",
    supportsTitleOverride: true,
    EditorForm: MyTasksEditor,
  },
};

registerWidget(myTasksDef);
